import React from 'react';
import { Tag } from 'rsuite';
import { PointAccountStatus, PointAccountStatusList } from '@/models/point-account.model';

const colorMap: Record<number, string> = {
  [PointAccountStatus.Draft]: 'orange',
  [PointAccountStatus.Active]: 'green',
  [PointAccountStatus.Paused]: 'yellow',
  [PointAccountStatus.Closed]: 'red',
};

const PointAccountStatusTag: React.FC<{ status: PointAccountStatus }> = ({ status }) => (
  <Tag color={colorMap[status] as any}>{PointAccountStatusList.find(s => s.value == status)?.label ?? status}</Tag>
);

export default PointAccountStatusTag;
